var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content_width_box"},[_vm._m(0),_c('FileTitleListView',{attrs:{"messageList":_vm.businessFileList.list,"perPage":_vm.businessFileList.perPage,"detailRouter":"invstorDetail"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content_title"},[_c('div',{staticClass:"title_left_h2"},[_vm._v("企业管治文件")])])
}]

export { render, staticRenderFns }